import { render, staticRenderFns } from "./MinisiteLanding.vue?vue&type=template&id=99448f62&scoped=true&"
import script from "./MinisiteLanding.vue?vue&type=script&lang=js&"
export * from "./MinisiteLanding.vue?vue&type=script&lang=js&"
import style0 from "./MinisiteLanding.vue?vue&type=style&index=0&id=99448f62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99448f62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99448f62')) {
      api.createRecord('99448f62', component.options)
    } else {
      api.reload('99448f62', component.options)
    }
    module.hot.accept("./MinisiteLanding.vue?vue&type=template&id=99448f62&scoped=true&", function () {
      api.rerender('99448f62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MinisiteLanding.vue"
export default component.exports